import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

/**
 * 配置路由
 */
Vue.use(VueRouter)


/**
 * 路由地址
 */
import Layout from '@/views/layout/index.vue'
import Login from '@/views/login/index.vue'
import NotFound from '@/views/404/index.vue'
import Empty from '@/views/empty/index.vue'


/**
 * 路由输出
 * 路由path为固定的，需要与当前登录的用户所获得的菜单权限进行匹配，以path为匹配的标准，如果与路由的path不符合则跳转到empty界面
 */
const routes: Array<RouteConfig> = [
  {
    path: "*",
    redirect: "/404"
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '/',
    redirect: "/Layout"
  },
  {
    path: '/empty',
    name: 'empty',
    component: Empty
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/layout',
    component: Layout,
    children: [
      {
        path: '/',
        name: '首页',
        component: () => import('@/views/home/index.vue'),
      },
      {
        path: '/home',
        name: '首页',
        component: () => import('@/views/home/index.vue'),
      },
      {
        path: '/order',
        name: '门店订单',
        component: () => import('@/views/order/index.vue'),
      },
      {
        path: '/orderDetail',
        name: '订单详情',
        component: () => import('@/views/order-detail/index.vue'),
      },
      {
        path: '/afterDetail',
        name: '退款详情',
        component: () => import('@/views/after-detail/index.vue'),
      },
      {
        path: '/returnDetail',
        name: '钱款去向',
        component: () => import('@/views/return-detail/index.vue'),
      },
      {
        path: '/productList',
        name: '商品',
        component: () => import('@/views/product-list/index.vue'),
      },
      {
        path: '/productCategory',
        name: '商品分类',
        component: () => import('@/views/product-category/index.vue'),
      },
      {
        path: '/vip',
        name: '会员中心',
        component: () => import('@/views/vip/index.vue'),
      },
      {
        path: '/vipInfo',
        name: '客户详情',
        component: () => import('@/views/vip-info/index.vue'),
      },
      {
        path: '/auditAccount',
        name: '审核账户',
        component: () => import('@/views/audit-account/index.vue'),
      },
      {
        path: '/settledPlatform',
        name: '入驻',
        component: () => import('@/views/settled-platform/index.vue'),
      },
      {
        path: '/auditWithdraw',
        name: '提现审核',
        component: () => import('@/views/audit-withdraw/index.vue'),
      },
      {
        path: '/afterSale',
        name: '退货退款',
        component: () => import('@/views/after-sale/index.vue'),
      },
      {
        path: '/equityDescribe',
        name: '权益说明',
        component: () => import('@/views/equity-describe/index.vue'),
      },
      {
        path: '/afterSaleRule',
        name: '售后规则',
        component: () => import('@/views/after-sale-rule/index.vue'),
      },
      {
        path: '/productFeedback',
        name: '商品需求',
        component: () => import('@/views/product-feedback/index.vue'),
      },
      {
        path: '/aboutRebate',
        name: '返利说明',
        component: () => import('@/views/about-rebate/index.vue'),
      },
      {
        path: '/aboutUs',
        name: '关于我们',
        component: () => import('@/views/about-us/index.vue'),
      },
      {
        path: '/carousel',
        name: '轮播图',
        component: () => import('@/views/carousel/index.vue'),
      },
      {
        path: '/freight',
        name: '运费设置',
        component: () => import('@/views/freight/index.vue'),
      },
      {
        path: '/admin',
        name: '管理员',
        component: () => import('@/views/admin/index.vue'),
      },
      {
        path: '/dataDictionary',
        name: '数据字典',
        component: () => import('@/views/data-dictionary/index.vue'),
      },
      {
        path: '/user',
        name: '用户列表',
        component: () => import('@/views/user/index.vue'),
      },
      {
        path: '/menu',
        name: '菜单列表',
        component: () => import('@/views/menu/index.vue'),
      },
      {
        path: '/resource',
        name: '资源列表',
        component: () => import('@/views/resource/index.vue'),
      },
      {
        path: '/resourceCategory',
        name: '资源分类',
        component: () => import('@/views/resource-category/index.vue'),
      },
      {
        path: '/memberProxyReport',
        name: '代理商报表信息',
        component: () => import('@/views/user-proxy/index.vue'),
      },
      {
        path: '/rechargeProject',
        name: '充值方案',
        component: () => import('@/views/recharge-project/index.vue'),
      },
      {
        path: '/rechargeRecord',
        name: '充值记录',
        component: () => import('@/views/recharge-record/index.vue'),
      },
      {
        path: '/addProduct',
        name: '添加商品',
        component: () => import('@/views/add-product/index.vue'),
      },
      {
        path: '/editProduct',
        name: '编辑商品',
        component: () => import('@/views/edit-product/index.vue'),
      },
      {
        path: '/sysAddress',
        name: '自提地址',
        component: () => import('@/views/address/index.vue'),
      },
      {
        path: '/operationBoard',
        name: '数据看板',
        component: () => import('@/views/operation-board/index.vue'),
      },
      {
        path: '/operationManager',
        name: '服务队',
        component: () => import('@/views/operation-manager/index.vue'),
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
